import {
    userService
} from '../_services';

// importamos las traducciones para gestionar los avisos
import i18n from '../i18n.js';


const state = {

    current: {
        data: {},
        loading: {},
        updating: {},
        error: {}
    },
    dog: {
        data: {},
        loading: false,
        error: {}
    }
}

const actions = {

    updateUser({
        dispatch,
        commit
    }, userData) {
        commit('updateRequest')       

        userService.update(userData)
            .then(
                user => {                 
                    dispatch('notifier/success', i18n.t('notifier_updated_user_ok'), {
                        root: true
                    });
                    commit('updateSuccess', user);
                },
                error => {                   
                    dispatch('notifier/error', error, {
                        root: true
                    });
                    commit('updateFailure', error);
                }
            )
    },

    /* funcion para solicitar el cambio de email de usuario */
    actChangeUserMail({commit}, data) {
        
        return new Promise((resolve, reject) => {

            userService.actChangeUserMail(data).then(res => {
                return resolve(res.data);
            }).catch(error => reject(error));

        })

    },

    /* funcion para verificar el cambio de email de un usuario dado el token */
    actUserValidateMailChange({ commit }, data) {

        return new Promise((resolve, reject) => {

            userService.actUserValidateMailChange(data).then(res => {
                return resolve(res.data);
            }).catch(error => reject(error));

        })

    }

}

const mutations = {
    /**
     * USUARIO
     */

    updateRequest(state) {
        state.current.updating = true
    },
    updateSuccess(state) {
        state.current.updating = false
    },
    updateFailure(state, error) {
        state.current.updating = false
        state.current.error = error
    },

    /*
     * PHONES
     */
    createPhoneSuccess(state, phones) {
        state.current.data.phones.push(phones.data)
    },
    updatePhoneSuccess(state, phones) {
        const id = phones.data.id
        var phone = state.current.data.phones.find(phones => phones.id === id)
        Object.assign(phone, phones.data)
    },
    deletePhoneSuccess(state, id) {
        state.current.data.phones = state.current.data.phones.filter(phone => phone.id !== id)
    },


}

export const usuario = {
    namespaced: true,
    state,
    actions,
    mutations
}